import React, { useEffect, useState } from "react";
import { API } from "../lib/api";

// On-device debug overlay. Renders ONLY in the Capacitor native build and only
// when the user has tapped the QUATTRO logo 5 times to enable it. Shows the
// resolved API base URL plus the last profile fetch outcome so we can debug
// "Profile didn't load" issues without a USB cable or remote dev tools.
//
// To enable: open the lobby, tap "QUATTRO" 5 times fast.
// To disable: tap the badge in the corner.
const ENABLE_KEY = "quattro_debug_enabled";

function isNative() {
  try {
    if (typeof window === "undefined" || !window.location) return false;
    const o = window.location.origin || "";
    return o.includes("localhost") || o.includes("127.0.0.1") || o.startsWith("capacitor:");
  } catch { return false; }
}

export default function DebugOverlay() {
  const [enabled, setEnabled] = useState(false);
  const [info, setInfo] = useState({ status: "—", url: "—", error: "—", uid: "—" });
  useEffect(() => {
    try {
      setEnabled(localStorage.getItem(ENABLE_KEY) === "1");
    } catch {}
  }, []);
  useEffect(() => {
    if (!enabled) return;
    let mounted = true;
    (async () => {
      const userId = (() => { try { return localStorage.getItem("quattro_user_id") || "—"; } catch { return "?"; } })();
      const target = `${API}/profile/${encodeURIComponent(userId)}`;
      try {
        const t0 = Date.now();
        const res = await fetch(target, { method: "GET" });
        const dt = Date.now() - t0;
        const body = await res.text();
        if (!mounted) return;
        setInfo({
          status: `HTTP ${res.status} in ${dt}ms`,
          url: target,
          error: body.substring(0, 200),
          uid: userId,
        });
      } catch (e) {
        if (!mounted) return;
        setInfo({
          status: "FETCH FAILED",
          url: target,
          error: (e && e.message) ? e.message : String(e),
          uid: userId,
        });
      }
    })();
    return () => { mounted = false; };
  }, [enabled]);
  if (!enabled) return null;
  return (
    <div
      style={{
        position: "fixed",
        bottom: 8, left: 8, right: 8,
        background: "rgba(0,0,0,0.92)",
        border: "1px solid #FFD700",
        borderRadius: 8,
        padding: 8,
        fontFamily: "monospace",
        fontSize: 10,
        lineHeight: 1.3,
        color: "#FFD700",
        zIndex: 99999,
        maxHeight: "40vh",
        overflow: "auto",
      }}
      data-testid="debug-overlay"
      onClick={() => {
        try { localStorage.removeItem(ENABLE_KEY); } catch {}
        setEnabled(false);
      }}
    >
      <div><b>QUATTRO DEBUG</b> (tap to hide)</div>
      <div>API: {API}</div>
      <div>Origin: {typeof window !== "undefined" ? window.location?.origin : "?"}</div>
      <div>UA: {typeof navigator !== "undefined" ? navigator.userAgent.substring(0,80) : "?"}</div>
      <div>UID: {info.uid}</div>
      <div>URL: {info.url}</div>
      <div>STATUS: {info.status}</div>
      <div style={{ color: "#FF8888" }}>BODY: {info.error}</div>
      <div>Native? {isNative() ? "YES" : "no"}</div>
    </div>
  );
}

// Helper a parent can call to enable the overlay without exposing the key.
export function enableDebug() {
  try { localStorage.setItem(ENABLE_KEY, "1"); } catch {}
  window.location.reload();
}
